export default __webpack_public_path__ + "static/media/roboto-v20-latin-italic.52e23852.ttf";